import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6768d8dd")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withId(({ Component }) => [
      (_openBlock(), _createBlock(_KeepAlive, { include: "Billing,reconciliationList" }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
      ], 1024))
    ]),
    _: 1
  }))
})